import React, {useEffect} from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import AppAppBar from '../components/AppAppBar';
import Footer from '../components/Footer';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import {motion} from 'framer-motion';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const Contact: React.FC = () => {
  const {t, i18n} = useTranslation();
  const currentLang = i18n.language;
  const localeI18n = localStorage.getItem('i18n');

  useEffect(() => {
    if (localeI18n) {
      i18n.changeLanguage(localeI18n);
    }
  }, [localeI18n, i18n]);

  return (
    <>
      <AppAppBar />
      <Box
        sx={{
          bgcolor: 'background.default',
          minHeight: '100vh',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '100%',
            background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
            opacity: 0.1,
            zIndex: 0,
          },
        }}
      >
        <Container
          maxWidth='lg'
          sx={{py: 8, mt: 8, position: 'relative', zIndex: 1}}
        >
          <motion.div
            initial={{opacity: 0, y: 20}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.5}}
          >
            <Typography
              variant='h3'
              component='h1'
              gutterBottom
              align='center'
              sx={{
                fontWeight: 'bold',
                mb: 2,
                background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {t('contactUs')}
            </Typography>
            <Typography
              variant='h6'
              component='h2'
              gutterBottom
              align='center'
              sx={{mb: 6, color: 'text.secondary'}}
            >
              {t('contactDescription')}
            </Typography>
          </motion.div>

          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <motion.div
                initial={{opacity: 0, x: -20}}
                animate={{opacity: 1, x: 0}}
                transition={{duration: 0.5, delay: 0.2}}
              >
                <Paper
                  elevation={3}
                  sx={{
                    p: 4,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    transition: 'transform 0.3s',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                    },
                  }}
                >
                  <ContactSupportIcon
                    sx={{fontSize: 40, color: 'primary.main', mb: 2}}
                  />
                  <Typography variant='h6' gutterBottom>
                    {t('contactSupport')}
                  </Typography>
                  <Typography variant='body1' color='text.secondary'>
                    {t('contactSupportDescription')}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={4}>
              <motion.div
                initial={{opacity: 0, y: 20}}
                animate={{opacity: 1, y: 0}}
                transition={{duration: 0.5, delay: 0.3}}
              >
                <Paper
                  elevation={3}
                  sx={{
                    p: 4,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    transition: 'transform 0.3s',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                    },
                  }}
                >
                  <EmailIcon
                    sx={{fontSize: 40, color: 'primary.main', mb: 2}}
                  />
                  <Typography variant='h6' gutterBottom>
                    {t('contactEmail')}
                  </Typography>
                  <Typography variant='body1' color='text.secondary'>
                    support@zzztech.com.tw
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={4}>
              <motion.div
                initial={{opacity: 0, x: 20}}
                animate={{opacity: 1, x: 0}}
                transition={{duration: 0.5, delay: 0.4}}
              >
                <Paper
                  elevation={3}
                  sx={{
                    p: 4,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    transition: 'transform 0.3s',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                    },
                  }}
                >
                  <ContactSupportIcon
                    sx={{fontSize: 40, color: 'primary.main', mb: 2}}
                  />
                  <Typography variant='h6' gutterBottom>
                    {t('contactLiveChat')}
                  </Typography>
                  <Typography variant='body1' color='text.secondary'>
                    {t('contactLiveChatDescription')}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          </Grid>

          <motion.div
            initial={{opacity: 0, y: 20}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.5, delay: 0.5}}
          >
            <Box
              sx={{
                height: '70vh',
                width: '100%',
                mt: 6,
              }}
            >
              <iframe
                title='platformContact'
                src={`https://zusers.zzztech.com.tw/platform/dbe66e89-2edc-55b5-9c6e-820110b08d5f/contact?lang=${currentLang}&isLangSelector=false&isTitle=false&fields=email,nickname,phone,message&isPlatformIcon=false&isPlatformName=false&isTitle=true&isExpand=true&style=modern`}
                width='100%'
                height='100%'
                style={{
                  border: 'none',
                  borderRadius: '8px',
                }}
              />
            </Box>
          </motion.div>
        </Container>
        <Footer />
      </Box>
    </>
  );
};

export default Contact;
